export default __webpack_public_path__ + "static/media/bird4.14cdeb4e.svg";